import { QueryFactory } from "../../../../Common";
export const QCashOutBet = QueryFactory("CashOutBet");
//# sourceMappingURL=QCashOutBet.js.map